export default {"src":"/_next/static/media/xml-svgrepo-com.1bb819aa.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};